import type { PageLoad } from './$types';
import type { PageData } from '$lib/metadataTypes/MetaTypes';

export const load: PageLoad = async ({ parent }): Promise<PageData> => {
  const { site, category } = await parent(); // parent() = CategoryData

  return {
    site,
    category,
    page: {
			title: "About the Authors",
description: "Introduces Freon’s creators, Jos Warmer and Anneke Kleppe, highlighting their backgrounds in software language engineering, UML, OCL, and domain-specific languages, along with key publications.",
tags: [ "Freon", "authors", "Jos Warmer", "Anneke Kleppe", "UML", "OCL", "DSL", "software engineering", "metamodeling", "modeling", "publications", "documentation"] ,
modifiedTime: "2025-11-07T17:20:18.649Z",
publishedTime: "2025-11-07T17:20:18.649Z"
    }
  };
};